import * as React from "react"
import type { SVGProps } from "react"
const SvgImageAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.59 20.56q.59.58 1.41.58h14q.83 0 1.41-.58.6-.6.59-1.42v-7a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v7H5v-14h7q.42 0 .71-.28a1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H5q-.82 0-1.41.59A2 2 0 0 0 3 5.14v14q0 .82.59 1.42" />
    <path d="m14.25 12.14 3.75 5H6l3-4 2.25 3zm1.75-5h1v1q0 .43.29.72t.71.28c.42 0 .52-.1.71-.28a1 1 0 0 0 .29-.72v-1h1q.42 0 .71-.28a1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-1v-1a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v1h-1a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .43.29.72t.71.28m-7.5 3q.63 0 1.06-.43.45-.45.44-1.07 0-.62-.44-1.06a1.5 1.5 0 0 0-1.06-.44q-.63 0-1.06.44A1.5 1.5 0 0 0 7 8.64q0 .63.44 1.07.43.43 1.06.43" />
  </svg>
)
export default SvgImageAdd
